// =============================================
// COMPONENTE: DRIVER NODE
// =============================================
// Arquivo: DriverNode.tsx
// Descrição: Nó para operações com motoristas
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { User } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const DriverNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, operation, driverId, description, actions } = data;

  const getOperationLabel = (op: string) => {
    const labels: Record<string, string> = {
      get: 'Buscar',
      register: 'Registrar',
      list: 'Listar'
    };
    return labels[op] || op;
  };

  return (
    <div className={`flow-node driver-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header driver-header">
        <User className="node-icon" size={18} />
        <span className="node-title">{label || 'Motorista'}</span>
      </div>

      <div className="node-body">
        {operation && (
          <div className="node-field">
            <span className="field-label">Operação:</span>
            <span className="field-value">{getOperationLabel(operation)}</span>
          </div>
        )}
        {driverId && (
          <div className="node-field">
            <span className="field-label">CPF/ID:</span>
            <span className="field-value code">{driverId}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default DriverNode;
